import { Typography, Box, styled, IconButton, Switch, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Dispatch, SetStateAction, useState } from 'react';
import { IForm } from '../../models/form/form';
import DeleteFormModal from './modal/DeleteFormModal';
import EditOnly from '../permissions/EditOnly';
import { canEdit } from '../../utils/permissions';
import { flags, languages } from '../../i18n';
import { theme } from '../../styles/themes/mainTheme';
import { useTranslation } from 'react-i18next';


const ElementWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F0F0F0',
    cursor: 'pointer',
    paddingInline: '3%',
    paddingBlock: '1%',
    marginBottom: '1%',
    borderRadius: 5,
    "&:hover": {
        backgroundColor: theme.palette.grey[300],
    }
}));

interface IFormListElementProps {
    form: IForm;
    onFormClick: (form: IForm) => void;
    setUpdateForms: Dispatch<SetStateAction<number>>;
    onSetFormActive: (form: IForm) => void;
    buildingId: number;
    propertyGroupId: number;
}

const FormListElement = ({ form, onFormClick, setUpdateForms, onSetFormActive, buildingId, propertyGroupId }: IFormListElementProps) => {
    const { t } = useTranslation(['form']);
    const [isDeleteFormShowing, setIsDeleteFormShowing] = useState<boolean>(false);

    const isFormActivated = () => {
        const formBuildingIndex = form.buildings.findIndex((b) => b.buildingId == buildingId);
        const formPropertyGroupIndex = form.propertyGroups.findIndex((pg) => pg.propertyGroupId == propertyGroupId);

        if (formBuildingIndex >= 0) {
            return form.buildings[formBuildingIndex].isActive;
        }
        if (formPropertyGroupIndex >= 0) {
            return form.propertyGroups[formPropertyGroupIndex].isActive;
        }
        return false;
    }

    return (
        <ElementWrapper>
            <DeleteFormModal groupId={form.groupId} isShowDelete={isDeleteFormShowing} setIsShowDelete={setIsDeleteFormShowing} setUpdateForms={setUpdateForms} />

            <Box width={"85%"} onClick={() => onFormClick(form)}>
                <Box>
                    <Typography display={'inline'} sx={{ fontWeight: '500', marginRight: 2 }}>
                        {form.name}
                    </Typography>
                    <img src={flags.get(languages.get(form.lang) || "fr")} height="13em" />
                </Box>

            </Box>

            <Box>
                <Tooltip title={t("form:activeSwitchTooltip")} placement='top' arrow><Switch checked={isFormActivated()} onChange={() => onSetFormActive(form)} disabled={!canEdit()} size='small' /></Tooltip>
                <EditOnly>
                    <IconButton onClick={() => setIsDeleteFormShowing(true)} sx={{ color: theme.palette.error.main }}>
                        <DeleteIcon></DeleteIcon>
                    </IconButton>
                </EditOnly>
            </Box>
        </ElementWrapper>
    );
};

export default FormListElement;
